
import _ from 'lodash';

/* @ngInject */
export default function officesFactory($http, HPConfig, $q, $window) {
    const isEditingOffice = false;

    const accountTypes = [
        {
            BankAccountTypeId: 1,
            Name: 'Checking',
            Description: 'Checking',
        },
        {
            BankAccountTypeId: 2,
            Name: 'Savings',
            Description: 'Savings',
        },
    ];

    const paymentStatuses = [
        {
            PaymentMethodStatusId: 1,
            Name: 'In Review',
            Description: 'In Review',
        },
        {
            PaymentMethodStatusId: 2,
            Name: 'Approved',
            Description: 'Approved',
        },
        {
            PaymentMethodStatusId: 3,
            Name: 'Rejected',
            Description: 'Rejected',
        },
    ];

    return {
        getOffices,
        getOfficeProfile,
        getStates,
        getServices,
        getCounties,
        getPaymentStatuses,
        getAccountTypes,
        saveLogo,
        saveInfo,
        saveProfile,
        saveContacts,
        saveFinanceInfo,
        saveNewOffice,
        reassignUsersAndDeleteOffice,
        validateImage,
        isEditingOffice,
    };

    function getOfficeProfile(params) {
        return $http({
            url: `${HPConfig.heroProApi}Contractor/Info`,
            method: 'GET',
            params,
        });
    }
    /** **
     *  HPF removing actual call to database. using reference to all 50 states instead
     *
     *
     *** */
    function getOffices() {
        return $http({
            url: `${HPConfig.heroProApi}Contractor/Location`,
            method: 'GET',
            params: {
                includeServiceStates: false,
                contractorStatusList: [2, 3, 10, 11],
            },
        });
    }


    function validateImage(src) {
        const deferred = $q.defer();

        const image = new $window.Image();

        image.onerror = function () {
            deferred.resolve(false);
        };
        image.onload = function () {
            deferred.resolve(true);
        };
        image.src = src;
        /* jshint ignore:end */
        return deferred.promise;
    }

    /* adding all 50 states instead of restricting to just CA */
    function getStates(_excludeInactive) {
        const _data = _excludeInactive || false;

        return $http({
            url: `${HPConfig.heroProApi}Address/States?excludeInactive=${_data}`,
            method: 'GET',
        });
    }

    function getServices() {
        return $http({
            url: `${HPConfig.heroProApi}Contractor/ContractorTypes`,
            method: 'GET',
            cache: true,
        });
    }

    function getCounties(stateGeoId) {
        const _params = {
            MuniStatusId: 1, // 1 == active munis, 2 == inactive munis currently defaulted to active munis
            StateGeoId: stateGeoId,
        };
        return $http({
            url: `${HPConfig.heroProApi}Contractor/Munis`,
            method: 'GET',
            params: _params,
            cache: true,
        });
    }

    function getPaymentStatuses() {
        const deferred = $q.defer();

        deferred.resolve(paymentStatuses);
        return deferred.promise;
    }

    function getAccountTypes() {
        const deferred = $q.defer();

        deferred.resolve(accountTypes);
        return deferred.promise;
    }

    function saveLogo(data) {
        return $http({
            url: `${HPConfig.heroProApi}Contractor/UploadLogo`,
            method: 'POST',
            headers: {
                'Content-Type': undefined,
            },
            processData: false,
            data,
        });
    }

    function saveInfo(data) {
        return $http({
            url: `${HPConfig.heroProApi}Contractor/Information`,
            method: 'POST',
            data,
        });
    }

    function saveProfile(data) {
        return $http({
            url: `${HPConfig.heroProApi}Contractor/Profile`,
            method: 'POST',
            data,
        });
    }

    function saveContacts(data) {
        return $http({
            url: `${HPConfig.heroProApi}Contractor/Contacts`,
            method: 'POST',
            data,
        });
    }

    function saveFinanceInfo(data) {
        return $http({
            url: `${HPConfig.heroProApi}Contractor/ACH`,
            method: 'POST',
            data,
        });
    }

    function saveNewOffice(data) {
        return $http({
            url: `${HPConfig.heroProApi}Contractor/Location`,
            method: 'POST',
            data,
        });
    }

    function reassignUsersAndDeleteOffice(data) {
        return $http({
            url: `${HPConfig.heroProApi}Contractor/Delete`,
            method: 'POST',
            data,
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/accounts/offices/officesFactory.js